import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface ResetPasswordData {
  password: string;
  identityId?: string;
  session?: string;
  aToken?: string;
  emailAddress?: string;
}

// Define schema that matches ResetPasswordResponse
const resetPasswordResponseSchema = z.object({
  idToken: z.string().optional(),
  refreshToken: z.string().optional(),
  message: z.string().optional(),
  title: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
});

// Extract type from schema
export type ResetPasswordResponse = z.infer<typeof resetPasswordResponseSchema>;

export default async function fetchResetPassword(
  url: string,
  data: ResetPasswordData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(url, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return resetPasswordResponseSchema.parse(result);
}
